var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tab } from '@headlessui/react';
import { useEffect, useState } from 'react';
import { ResponseBody } from '../response-body/ResponseBody';
import { ResponseHeaders } from '../response-headers/ResponseHeaders';
import { Panel, PanelBody, PanelHeader, PanelTab } from '../ui/Panel';
export function ResponseView({ response, time }) {
    const [body, setBody] = useState(null);
    useEffect(() => {
        if (response.body && !response.bodyUsed) {
            const setBodyWithText = () => __awaiter(this, void 0, void 0, function* () {
                setBody(yield response.text());
            });
            setBodyWithText();
        }
    }, [response, response.bodyUsed]);
    const hasBody = response.body !== null;
    const contentType = response.headers.get('content-type');
    return (_jsxs(Tab.Group, { defaultIndex: 0, as: Panel, className: "h-full", children: [_jsxs(Tab.List, { as: PanelHeader, children: [hasBody && _jsx(PanelTab, { children: "Body" }), _jsx(PanelTab, { children: "Headers" })] }), _jsxs(Tab.Panels, { className: "min-h-0 flex-1", children: [hasBody && (_jsxs(Tab.Panel, { as: PanelBody, children: [body && _jsx(ResponseBody, { content: body, contentType: contentType }), !body && _jsx("div", { className: "px-3 py-3 text-xs font-medium text-zinc-950 dark:text-white", children: "Reading data\u2026" })] })), _jsx(Tab.Panel, { as: PanelBody, children: _jsx(ResponseHeaders, { response: response }) })] })] }));
}
